<div class="row">
    <div class="col-xl-4">
        <div class="card card-box-alt card-border-top border-success mb-5 pb-4">
            <h3 class="font-size-lg font-weight-bold mt-5 mb-4">Lightweight</h3>
            <p class="card-text px-4 mb-4">
                Insects and flies, then I feel the presence of the indescribable forms Almighty, who formed us in his own image.
            </p>
            <a [routerLink]="" class="btn btn-link btn-link-first mb-2 p-0" title="Find out more">
                <span>Find out more</span>
            </a>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box-alt card-border-top border-first mb-5 pb-4">
            <h3 class="font-size-lg font-weight-bold mt-5 mb-4">Simple to use</h3>
            <p class="card-text px-4 mb-4">
                When, while the lovely valley teems with vapour present moment around me, and the meridian sun strike.
            </p>
            <a [routerLink]="" class="btn btn-link btn-link-first mb-2 p-0" title="Find out more">
                <span>Find out more</span>
            </a>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box-alt card-border-top border-warning mb-5 pb-4">
            <h3 class="font-size-lg font-weight-bold mt-5 mb-4">Starter Templates</h3>
            <p class="card-text px-4 mb-4">
                Exquisite sense of mere tranquil existence, that I neglect my foliage world  trickling tree artist talents.
            </p>
            <a [routerLink]="" class="btn btn-link btn-link-first mb-2 p-0" title="Find out more">
                <span>Find out more</span>
            </a>
        </div>
    </div>
</div>
